import { QSetStatus } from '@exam-management/graphql';
import { LabelColor } from '@shared/components';

export const QSET_COLOR_STATUS = {
  [QSetStatus.Draft]: LabelColor.INFO,
  [QSetStatus.Disabled]: LabelColor.GREY,
  [QSetStatus.InReview]: LabelColor.WARNING,
  [QSetStatus.Published]: LabelColor.SUCCESS,
  [QSetStatus.Reviewed]: LabelColor.SUCCESS,
  [QSetStatus.Unpublished]: LabelColor.WARNING,
};

export const QSET_STATUS_TEXT = {
  [QSetStatus.Disabled]: 'Disabled',
  [QSetStatus.Draft]: 'Draft',
  [QSetStatus.InReview]: 'In Review',
  [QSetStatus.Published]: 'Published',
  [QSetStatus.Reviewed]: 'Reviewed',
  [QSetStatus.Unpublished]: 'Unpublished',
};
